module.exports = __webpack_public_path__ + "static/media/YesYellow.073cd20a.png";